<template>
  <div class="sidebar widgets" v-if="facets">
    <SidebarFacetGroup v-for="facetGroup in facets" :key="facetGroup.id" :group="facetGroup" class="widget"/>
  </div>
</template>

<script>
import SidebarFacetGroup from "./SidebarFacetGroup";
import {mapGetters} from "vuex";

export default {
  name: "SidebarFacets",
  components: {SidebarFacetGroup},

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      facets: 'search/sidebarFacets',
    }),
  },


}
</script>
